export default __webpack_public_path__ + "static/media/Mini Juli.12fa1d93.jpg";